import { useEffect } from "react";

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
  return target.isContentEditable;
}

/**
 * Escape exits selection mode; Ctrl/Cmd+A runs `onSelectAllInView` when not in a text field.
 */
export function useSelectionKeyboardShortcuts(options: {
  enabled: boolean;
  onExit: () => void;
  onSelectAllInView?: () => void;
}): void {
  const { enabled, onExit, onSelectAllInView } = options;

  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onExit();
        return;
      }
      if (onSelectAllInView && (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
        if (isTypingTarget(e.target)) return;
        e.preventDefault();
        onSelectAllInView();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [enabled, onExit, onSelectAllInView]);
}
